import React, { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import {
  Box,
  Button,
  Grid,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as OkIcon } from '../../assets/img/icon/Ok.svg';
import SubHeader from '../../components/Header/SubHeader.component';
import SuraCard from '../../components/SuraCard';
import { ProductImagesList } from '../../constants/products.constant';
import { useAuthDataContext } from '../../context/auth/auth.provider';
import {
  PRODUCTS_QUERY,
  PRODUCTS_QUERY_CONFIG,
  productsQuery,
} from '../../query/products/products';
import { useProductNavigationStore } from '../../stores/Navigation/product-navigation.store';

const useStyle = makeStyles(() =>
  createStyles({
    selectionCard: {
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      cursor: 'pointer',

      '& img': {
        maxWidth: '60px',
        height: '30px',
      },
    },
    borderedCard: {
      border: '1px solid #FA6400',
    },
    check: {
      position: 'absolute',
      top: '5%',
      right: '5%',
    },
    checked: {
      '& path': {
        stroke: '#FA6400',
      },
    },
    cardContent: {
      display: 'flex',
      width: '80%',
    },
    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
    },
    productTitle: {
      marginTop: '25px',
      marginBottom: '20px',
    },
    buttonContainer: {
      marginTop: '20px',
      marginBottom: '20px',
      display: 'flex',
    },
  })
);

const ProductItem = (props: any) => {
  const { title, img, onChange, checked, disabled } = props;
  const [selected, setSelected] = useState(checked);
  const classes = useStyle();

  const cardStyles = selected
    ? classes.selectionCard + ' ' + classes.borderedCard
    : classes.selectionCard;

  const selectCard = () => {
    onChange(!selected);
    setSelected(!selected);
  };

  const icon =
    ProductImagesList.filter((element) => element.icon === img)[0]?.image ||
    'default';

  return (
    <Box m={1} onClick={disabled ? undefined : selectCard}>
      <SuraCard className={cardStyles}>
        <Box p={3} pl={0} className={classes.cardContent}>
          <Box flex={1} className={classes.imageContainer}>
            <img
              src={require(`../../assets/img/products/${icon}.svg`)}
              alt="part"
            />
          </Box>

          <Box ml={2} flex={5}>
            <Typography variant="body2" align="left">
              {' '}
              {title}{' '}
            </Typography>
          </Box>

          <Box>
            <OkIcon />
          </Box>
        </Box>
      </SuraCard>
    </Box>
  );
};

interface MultiProductProps {
  header_title: string;
  subtitle: string;
  finishSelection: any;
  filterProducts: any;
}

const MultiProduct: React.FC<MultiProductProps> = ({
  header_title, // "Seleccionar producto"
  subtitle, // "Accedé a tu documentación"
  finishSelection,
  filterProducts,
}) => {
  const classes = useStyle();

  const history = useHistory();

  const [products_list, set_products] = useState<Set<number>>(new Set());
  const [products_description] = useState<Set<string>>(new Set());

  const { data: products } = useQuery(
    PRODUCTS_QUERY,
    productsQuery,
    PRODUCTS_QUERY_CONFIG
  );

  const setLastPageVisited = useProductNavigationStore(
    (state) => state.setLastPageVisited
  );
  const navigate_constants = useProductNavigationStore(
    (state) => state.constants
  );

  const updateSelectedProducts = useCallback(
    (product) => {
      if (products_list.has(product.code)) {
        products_list.delete(product.code);
        products_description.delete(product.description);
      } else {
        products_list.add(product.code);
        products_description.add(product.description);
      }
      filterProducts(Array.from(products_list));
      set_products(products_list);
    },
    [products_list, filterProducts, products_description]
  );

  setLastPageVisited(navigate_constants.MULTI_PRODUCT);

  const navigateBackFrom = useProductNavigationStore(
    (state) => state.navigateBackFrom
  );

  const { embed } = useAuthDataContext();

  const goBack = () => {
    navigateBackFrom(navigate_constants.MULTI_PRODUCT);
    if (embed) window.parent.postMessage({ return: 'overview' }, '*');
    else history.push(`/dashboard`);
  };

  return (
    <>
      <SubHeader
        content={
          <Box>
            <Typography variant="h6"> {header_title} </Typography>
          </Box>
        }
        goBack={() => goBack()}
      ></SubHeader>

      <Grid container justify="center" alignItems="center">
        <Grid item xs={11} md={11}>
          <Typography variant="h6" className={classes.productTitle}>
            {' '}
            {subtitle}{' '}
          </Typography>

          <Grid container>
            {products?.map((product: any, index: number) => (
              <Grid item xs={12} sm={6} key={index}>
                <ProductItem
                  onChange={() => updateSelectedProducts(product)}
                  title={product.description}
                  img={product.icon}
                />
              </Grid>
            ))}
          </Grid>

          <Grid container justify="center">
            <Grid
              item
              xs={11}
              md={11}
              justify="center"
              className={classes.buttonContainer}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() =>
                  finishSelection(Array.from(products_description))
                }
                disabled={!products_description?.size}
              >
                Continuar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default MultiProduct;
